import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    return Promise.reject(err);
  }
);

export const imageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http") || path.startsWith("/api/")) return path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
  return `${API_BASE}/images/${path}`;
};
